import { Configuration, DefaultApiFactory } from "@leafly-com/reservations-api";

import publicConfig from "config/public";

export const resApiClient = DefaultApiFactory(
  new Configuration({
    baseOptions: {
      headers: {
        "Content-Type": "application/json",
        "X-Leafly-Id": "web-web",
      },
      withCredentials: true,
    },
  }),
  publicConfig.services.reservationsApi.url
);
